import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { GET_SCORING_RESULTS_REPORT_ENTRIES } from '../../types';
import { SCORING_RESULTS_REPORT_ENTRIES_LOG_MESSAGES } from '../../constants/scoringResultsReportEntriesMessages';
import { getScoringResultsReportEntriesPending, getScoringResultsReportEntriesFulfilled, getScoringResultsReportEntriesRejected } from '../../actions';
import { sendApiRequest, notifyError, notifyWarning } from '../../../../actions';
import { scoringResultsReportFiltersSelector } from '../../selectors';
import generateError from '../../../../utilities/generateError';

const createPayload = payload => ({
  method: 'get',
  url: 'client/scoringExportInfo',
  onSuccess: [response => (response.data.length === 0
    ? notifyWarning(SCORING_RESULTS_REPORT_ENTRIES_LOG_MESSAGES.NOT_FOUND)
    : getScoringResultsReportEntriesFulfilled(response))],
  onError: [
    getScoringResultsReportEntriesRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});
const meta = {
  api: 'ajaxApi',
};

const getScoringResultsReportEntriesEpic$ = (action$, state$) => action$.pipe(
  ofType(GET_SCORING_RESULTS_REPORT_ENTRIES.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => {
    const filters = scoringResultsReportFiltersSelector(state$.value);
    return merge(
      of(getScoringResultsReportEntriesPending()),
      of(sendApiRequest(createPayload({ ...payload, ...filters }), meta)),
    );
  }),
);

export default getScoringResultsReportEntriesEpic$;


// WEBPACK FOOTER //
// ./src/features/reports/epics/scoring-results/getScoringResultsReportEntriesEpic.js